import { PropsWithChildren, useEffect, useState } from "react";
import { OverlayScrollbarWrapper } from "../../common/components";
import { StudioContext, StudioContextType } from "./StudioContext";

interface Props extends PropsWithChildren {
  value: StudioContextType;
}

export const StudioContextProvider = ({ children, value }: Props) => {
  const [isLoading, setisLoading] = useState(true);

  useEffect(() => {
    const hasProjectContext =
      value.editorConfig?.allowMissingProjectContext ||
      (value.projectId && value.teamId);

    if (
      value.designId &&
      hasProjectContext &&
      value.designState &&
      value.productName &&
      isLoading
    ) {
      setisLoading(false);
    }
  }, [
    isLoading,
    value.designId,
    value.designState,
    value.editorConfig?.allowMissingProjectContext,
    value.productName,
    value.projectId,
    value.teamId,
  ]);

  return (
    <StudioContext.Provider value={{ ...value, isLoading }}>
      <OverlayScrollbarWrapper style={{ maxHeight: "100vh" }}>
        {children}
      </OverlayScrollbarWrapper>
    </StudioContext.Provider>
  );
};
